import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Esemplare } from "../../types"
import EsemplareForm from "./EsemplareForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesEsemplare, validationSchemaEsemplare } from "./EsemplareCommon"

export default function EsemplareModal({
  title,
  esemplare,
  save,
  show,
  onClose,
  showEdizione = false,
}: {
  title: string
  esemplare?: Esemplare
  save: (values: Esemplare) => Promise<void>
  show: boolean
  onClose: () => void
  showEdizione?: boolean
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesEsemplare(esemplare) as Esemplare}
      validationSchema={validationSchemaEsemplare(showEdizione)}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>
                <ModalTitle>{title}</ModalTitle>
              </ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <EsemplareForm showEdizione={showEdizione} col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
